export default "__VITE_ASSET__C6ZjnnCz__"